export default __webpack_public_path__ + "static/media/vys.e5d679ba.mp4";